import { useLocation } from "react-router-dom";
import { useAppNavigate } from "@/hooks/useAppNavigate";

import Details from "../Blocks/Modals/SettingsModal/Details/Details";
import SettingsModal from "../Blocks/Modals/SettingsModal/SettingsModal";
import { getCurrentSectionData, getRouteToNextTab } from "./_utils";
import {
  DetailSectionNames,
  DetailSectionsRoutes,
  enumDetailSettings
} from "@/providers/NavigationProvider";
import * as StateLib from "@/Utils/StateLib";
import cx from "classnames";
import Header from "@/appComponents/Navigation/Header/Header";
import { appstr } from "@coreapp/utils/appstr";
import { CapitalizeFirstWord } from "@/Utils/DataLib";

const DetailsPage = () => {
  const nav = useAppNavigate();
  let wsMgr = StateLib.GetWSMgr();
  const isPlan = wsMgr.GetDoc()?.IsPlanChart() ?? false;

  // ['', 'details', sectionName]
  const location = useLocation();
  const [, , sectionRoute] = location.pathname.split("/");
  const { sectionKey, tabIndex } = getCurrentSectionData(
    sectionRoute,
    "ApplicationDetails",
    DetailSectionsRoutes,
    enumDetailSettings
  );

  const handleChangeCurrentTab = nextTab => {
    const route = getRouteToNextTab(nextTab, enumDetailSettings, DetailSectionsRoutes);
    nav.navigateDetails(route);
    wsMgr.UpdateDocTitle();
  };

  let subtitle = CapitalizeFirstWord(appstr(DetailSectionNames[sectionKey]));
  if (isPlan && sectionKey === "ChartDetails") {
    // We can show a Plan subtitle without changing the URL
    subtitle = appstr("Plan");
  }

  return (
    <>
      <div className={cx("appHeader--modal")}>
        <Header customToolbarClass={"oc-settings-toolbar"} />
        <SettingsModal title={appstr("Details")} subtitle={subtitle}>
          {({ onCloseModal }) => (
            <Details
              currentTab={tabIndex}
              setCurrentTab={handleChangeCurrentTab}
              onCloseModal={onCloseModal}
            />
          )}
        </SettingsModal>
      </div>
    </>
  );
};
export default DetailsPage;
